import { FC, useEffect, useState } from "react";
import eye from "../../assets/images/eye.svg";
import eyeShow from "../../assets/images/eye-show.svg";
import error from "../../assets/images/error.svg";
import React from "react";
import { TextField } from "@mui/material";
interface IInput {
  label?: any;
  type?: string;
  placeholder?: string;
  name?: string;
  errFl?: Boolean;
  errEmpty?: Boolean;
  errorMsg?: string;
  requireMsg?: string;
  areaCode?: boolean;
  icon?:any;
  onChange?(value: string): any;
  onFocus?(): any;
  onBlur?(): any;
  defaultValue?: string;
  [k: string]: any;
}
const Input: FC<IInput> = function ({
  label,
  type = "text",
  name = "",
  placeholder = "",
  errFl = false,
  errEmpty = false,
  errorMsg,
  requireMsg,
  icon,
  areaCode = false,
  onChange = () => {},
  onFocus = () => {},
  onBlur = () => {},
  defaultValue = "",
  ...rest
}) {
  const [IsPassword, setIsPassword] = useState(type === "password");
  const [Active, setActive] = useState(!!defaultValue || false);
  const [Value, setValue] = useState(defaultValue);
  const [validEmail, setValidEmail] = useState(false);
  const [validPhone, setValidPhone] = useState(false);
  const [CurrentType, setCurrentType] = useState(type);

  useEffect(() => {
    defaultValue !== "" && setActive(true);
    setValue(defaultValue);
  }, [defaultValue]);

  const emailRegex = /^$|\S+@\S+\.\S+/;
  const phoneRegex = /((09|03|07|08|05)+([0-9]{8})\b)/g;

  const onChangeInput = (e:any) => {
    setValue(e.target.value);
    onChange(e.target.value);
    setActive(true);

    // const email = e.target.value;
    // if (emailRegex.test(email)) {
    //   setValidEmail(true);
    //   setFlagError(false);
    // } else {
    //   setValidEmail(false);
    //   setFlagError(true);
    // }
    // if (name === "phone") {
    //   const phone = e.target.value;
    //   if (phoneRegex.test(phone)) {
    //     setValidPhone(true);
    //     setFlagError(false);
    //   } else {
    //     setValidPhone(false);
    //     setFlagError(true);
    //   }
    // }
  };

  useEffect(() => {
    setCurrentType(IsPassword ? "password" : "text");
  }, [IsPassword]);

  const onFocusInput = () => {
    onFocus();
    setActive(true);
    let getInputForm = document.getElementsByClassName("inputForm");
    if (getInputForm && getInputForm?.length > 0) {
      for (var i = 0; i < getInputForm.length; i++) {
        getInputForm[i].removeAttribute("readonly");
      }
    }
  };
  const onBlurInput = () => {
    Value === "" && setActive(false);
    onBlur();
  };
  return (
    <>
    <div className="line">
        {icon ?
          <div className="line__left">
            <img src={icon} alt="icon" />
          </div>
          : ""}
      <div className="container-input">
        <div className="row-input" {...rest}>
          {label && (
            <div className="label">
              <img src={label} alt="" />
            </div>
          )}

          <div className={`input-placeholder ${Active ? "active" : ""}`}>
            {areaCode && <span> +84 </span>}
            {!areaCode && <span className="placeholder">{placeholder}</span>}
            {type === "date"?
                <TextField
                  id="date"
                  name={name}
                  type="date"
                  value={Value}
                  onChange={onChangeInput}
                />:
                <input
                  className="inputForm"
                  readOnly
                  onFocus={onFocusInput}
                  onBlur={onBlurInput}
                  onChange={onChangeInput}
                  name={name}
                  value={Value}
                  type={CurrentType}
                />
              }
            {type === "password" ? (
              <img
                onClick={() => {
                  setIsPassword(!IsPassword);
                }}
                className="eye"
                src={IsPassword ? eye : eyeShow}
                alt=""
              />
            ) : null}
          </div>
        </div>
        {errFl? (
          <div
            className={`${validEmail || validPhone ? "hidden" : "row-input1"}`}
          >
            <div className="label">
              <img src={error} alt="" />
            </div>
            <div className="error">{errorMsg}</div>
          </div>
        ) : null}
        {errEmpty? (
          <div
            className={`${!errFl && errEmpty ? "row-input1" : "hidden"}`}
          >
            <div className="label">
              <img src={error} alt="" />
            </div>
            <div className="error">{requireMsg}</div>
          </div>
        ) : null}
      </div>
    </div>
    </>
  );
};

export default Input;
